var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Glass',{staticClass:"glass",attrs:{"progress":_vm.currentProgress,"annotation":_vm.currentAnnotation}})
}
var staticRenderFns = []

export { render, staticRenderFns }